import ReassuranceDrawer from '../shared/reassuranceDrawer.class';
export function initReassuranceDrawer() {
  const openButton = document.querySelector('.js-open-drawer-reassurance');
  if (!openButton) {
    return;
  }
  return new ReassuranceDrawer({
    drawerClass: 'js-drawer-reassurance',
    openButtonClass: 'js-open-drawer-reassurance'
  });
}